// Version : 1.0.0
// Author : AGALYA

import AddMemberActionType from './add-member.types';

/** ***************** FETCH EXISTING MEMBER DETAILS START *********************** */
export const fetchExistsMemberDetailsStart = (bankCredentils: any) => ({
	type: AddMemberActionType.GET_MEMBER_DETAILS_START,
	payload: bankCredentils,
});

export const fetchExistsMemberDetailsSuccess = (bank: any) => ({
	type: AddMemberActionType.GET_MEMBER_DETAILS_SUCCESS,
	payload: bank,
});

export const fetchExistsMemberDetailsFailure = (error: any) => ({
	type: AddMemberActionType.GET_MEMBER_DETAILS_FAILURE,
	payload: error,
});

export const fetchExistsMemberDetailsResponseResetStart = () => ({
	type: AddMemberActionType.GET_MEMBER_DETAILS_RESPONSE_REST_START,
});

export const fetchExistsMemberDetailsResponseChanged = () => ({
	type: AddMemberActionType.GET_MEMBER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH EXISTING MEMBER DETAILS START *********************** */

/** ***************** FETCH PARTICULAR MEMBER DETAILS START *********************** */
export const fetchMemberDataStart = (data: any) => ({
	type: AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_START,
	payload: data,
});

export const fetchMemberDataSuccess = (bank: any) => ({
	type: AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_SUCCESS,
	payload: bank,
});

export const fetchMemberDataFailure = (error: any) => ({
	type: AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_FAILURE,
	payload: error,
});

export const fetchMemberDataResponseResetStart = () => ({
	type: AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_RESPONSE_REST_START,
});

export const fetchMemberDataResponseChanged = () => ({
	type: AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH PARTICULAR MEMBER DETAILS END *********************** */

/** ***************** GET MEMBER MANDATORY FIELDS START *********************** */
export const getMemberMandatoryStart = (data: any) => ({
	type: AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_START,
	payload: data,
});

export const getMemberMandatorySuccess = (bank: any) => ({
	type: AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_SUCCESS,
	payload: bank,
});

export const getMemberMandatoryFailure = (error: any) => ({
	type: AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_FAILURE,
	payload: error,
});

export const getMemberMandatoryResponseResetStart = () => ({
	type: AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_RESPONSE_REST_START,
});

export const getMemberMandatoryResponseChanged = () => ({
	type: AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_RESPONSE_CHANGED,
});
/** ***************** GET MEMBER MANDATORY FIELDS END *********************** */

/** ***************** CHECK ALL MANDATORY FIELDS START *********************** */
export const checkMandatoryFieldsStart = (data: any) => ({
	type: AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_START,
	payload: data,
});

export const checkMandatoryFieldsSuccess = (data: any) => ({
	type: AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_SUCCESS,
	payload: data,
});

export const checkMandatoryFieldsFailure = (error: any) => ({
	type: AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_FAILURE,
	payload: error,
});

export const checkMandatoryFieldsResetStart = () => ({
	type: AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_RESET_START,
});

export const checkMandatoryFieldsRespChanged = () => ({
	type: AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_CHANGED,
});
/** ***************** CHECK ALL MANDATORY FIELDS END *********************** */

/** ***************** FETCH ADD MEMBER LIST START *********************** */
export const fetchAddMemberListStart = (Credentils: any) => ({
	type: AddMemberActionType.FETCH_ADD_MEMBER_LIST_START,
	payload: Credentils,
});

export const fetchAddMemberListSuccess = (Credentils: any) => ({
	type: AddMemberActionType.FETCH_ADD_MEMBER_LIST_SUCCESS,
	payload: Credentils,
});

export const fetchAddMemberListFailure = (error: any) => ({
	type: AddMemberActionType.FETCH_ADD_MEMBER_LIST_FAILURE,
	payload: error,
});

export const fetchAddMemberListResponseResetStart = () => ({
	type: AddMemberActionType.FETCH_ADD_MEMBER_LIST_RESPONSE_REST_START,
});

export const fetchAddMemberListResponseChanged = () => ({
	type: AddMemberActionType.FETCH_ADD_MEMBER_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH ADD MEMBER LIST END *********************** */

/** ***************** EXPORT MEMBER LIST START *********************** */
export const exportMemberListStart = (Credentils: any) => ({
	type: AddMemberActionType.EXPORT_MEMBER_LIST_START,
	payload: Credentils,
});

export const exportMemberListSuccess = (Credentils: any) => ({
	type: AddMemberActionType.EXPORT_MEMBER_LIST_SUCCESS,
	payload: Credentils,
});

export const exportMemberListFailure = (error: any) => ({
	type: AddMemberActionType.EXPORT_MEMBER_LIST_FAILURE,
	payload: error,
});

export const exportMemberListResponseResetStart = () => ({
	type: AddMemberActionType.EXPORT_MEMBER_LIST_RESPONSE_REST_START,
});

export const exportMemberListResponseChanged = () => ({
	type: AddMemberActionType.EXPORT_MEMBER_LIST_RESPONSE_CHANGED,
});
/** ***************** EXPORT MEMBER LIST END *********************** */

/** ***************** DELETE MEMBER START *********************** */
export const deleteMemberStart = (Credentils: any) => ({
	type: AddMemberActionType.DELETE_MEMBER_START,
	payload: Credentils,
});

export const deleteMemberSuccess = (Credentils: any) => ({
	type: AddMemberActionType.DELETE_MEMBER_SUCCESS,
	payload: Credentils,
});

export const deleteMemberFailure = (error: any) => ({
	type: AddMemberActionType.DELETE_MEMBER_FAILURE,
	payload: error,
});

export const deleteMemberResponseResetStart = () => ({
	type: AddMemberActionType.DELETE_MEMBER_RESPONSE_RESET_START,
});

export const deleteMemberResponseChanged = () => ({
	type: AddMemberActionType.DELETE_MEMBER_RESPONSE_CHANGED,
});
/** ***************** DELETE MEMBER END *********************** */
